import {formatPrice} from './currency-format'
import {getSortedArray} from './array-helper'
import dayjs from 'dayjs'
import timezone from 'dayjs/plugin/timezone'
import utc from 'dayjs/plugin/utc'
import advancedFormat from 'dayjs/plugin/advancedFormat'
dayjs.extend(utc)
dayjs.extend(advancedFormat)
dayjs.extend(timezone)

const orderJSON = {
  coupons: [
    {
      name: 'New Customer Incentive Marketing Center',
      isValid: true,
      description: 'Marketing Center One Invoice Free',
      type: 'percent',
      duration: 'single_use',
      durationUnit: null,
      durationAmount: null,
      appliesToAllPlans: false,
      appliesToPlans: [
        'previewtax',
        'mc_pro-5-thryv-m2m',
        'mc_plus-5-thryv-m2m',
        'convenience-fee',
      ],
      isPercentDiscount: true,
      discountAmount: 0,
      discountPercent: 100,
      code: 'nci-mc',
    },
  ],
  plans: [
    {
      id: 'sww2xqbxxzxn',
      code: 'mc_pro-5-thryv-m2m',
      name: 'Marketing Center Pro',
      quantity: 1,
      intervalLength: 1,
      intervalUnit: 'months',
      currency: {
        currency: 'USD',
        setupFee: 0,
        unitAmount: 358,
      },
      addons: [],
      transitionApplies: true,
    },
    {
      id: 'vbqr2yjruz9q',
      code: 'rc_plus-5-thryv-m2m',
      name: 'Reporting Center Plus',
      quantity: 1,
      intervalLength: 1,
      intervalUnit: 'months',
      currency: {
        currency: 'USD',
        setupFee: 0,
        unitAmount: 51,
      },
      addons: [],
      transitionApplies: false,
    },
    {
      id: 'vj8d6f9bt3yo',
      code: 'seobase-5-thryv-m2m',
      name: 'SEO',
      quantity: 1100,
      intervalLength: 1,
      intervalUnit: 'months',
      currency: {
        currency: 'USD',
        setupFee: 0,
        unitAmount: 1,
      },
      addons: [
        {
          id: 'vj9as0xlyvrz',
          code: 'addon-5-seokey-m2m',
          name: 'SEO Keywords',
          quantity: 1,
          currencies: [
            {
              currency: 'AUD',
              unitAmount: 600,
            },
            {
              currency: 'CAD',
              unitAmount: 0,
            },
            {
              currency: 'NZD',
              unitAmount: 700,
            },
            {
              currency: 'USD',
              unitAmount: 400,
            },
          ],
        },
        {
          id: 'vj9as0xm5dm5',
          code: 'addon-5-seopb-m2m',
          name: 'SEO PowerBoost',
          quantity: 1,
          currencies: [
            {
              currency: 'AUD',
              unitAmount: 600,
            },
            {
              currency: 'CAD',
              unitAmount: 0,
            },
            {
              currency: 'NZD',
              unitAmount: 700,
            },
            {
              currency: 'USD',
              unitAmount: 400,
            },
          ],
        },
      ],
      transitionApplies: false,
    },
    {
      id: 'swv5n2fg12us',
      code: 'appmarket-5-thryv-m2m',
      name: 'Thryv Add-Ons',
      quantity: 1,
      intervalLength: 1,
      intervalUnit: 'months',
      currency: {
        currency: 'USD',
        setupFee: 0,
        unitAmount: 0,
      },
      addons: [
        {
          id: 't3l27ic1fdum',
          code: 'addon-5-signatures_usage',
          name: 'Signatures Usage',
          quantity: 1,
          currencies: [],
        },
        {
          id: 't6ytsi2ykfe1',
          code: 'app-websitebuilder',
          name: 'Website Builder',
          quantity: 1,
          currencies: [
            {
              currency: 'AUD',
              unitAmount: 0,
            },
            {
              currency: 'CAD',
              unitAmount: 0,
            },
            {
              currency: 'NZD',
              unitAmount: 0,
            },
            {
              currency: 'USD',
              unitAmount: 0,
            },
          ],
        },
        {
          id: 'vm1udwhyxl5v',
          code: 'addon-5-mcexpangr',
          name: 'Expanded Growth Package',
          quantity: 1,
          currencies: [
            {
              currency: 'AUD',
              unitAmount: 454.55,
            },
            {
              currency: 'CAD',
              unitAmount: 0,
            },
            {
              currency: 'NZD',
              unitAmount: 500,
            },
            {
              currency: 'USD',
              unitAmount: 500,
            },
          ],
        },
      ],
      transitionApplies: false,
    },
    {
      id: 'swfnqfat3lcf',
      code: 'cc_basicpls-5-thryv-m2m',
      name: 'My Account Basic+',
      quantity: 1,
      intervalLength: 1,
      intervalUnit: 'months',
      currency: {
        currency: 'USD',
        setupFee: 0,
        unitAmount: 0,
      },
      addons: [],
      transitionApplies: false,
    },
    {
      id: 'szppd9c7or2j',
      code: 'thryvprfee',
      name: 'Onboarding Fee',
      currency: {
        currency: 'USD',
        unitAmount: 250,
      },
      quantity: 1,
    },
  ],
  businessAddress: {
    address: '2200 West Airfield Drive',
    city: 'Dallas',
    state: 'TX',
    postalCode: '76051',
    xpCode: null,
    firstName: 'Credit',
    lastName: 'Cleaning',
    phone: '3174312304',
  },
  country: 'US',
  balanceInfo: {
    currency: 'USD',
    amount: -50,
    processingPrepaymentAmount: 0,
    availableCreditAmount: -50,
  },
  curr: 'USD',
  flow: 'new',
  isInvoiceBilled: false,
  isCohort: false,
}

console.log(orderJSON)

const getPlanDetail = (currency, plan) => {
  let currencyDetails = plan?.currencies
    ? plan.currencies.find(item => item.currency === currency)
    : plan?.currency
  let planAmount = (currencyDetails?.unitAmount || 0) * plan.quantity || 0

  return {
    name: plan.name,
    amount: planAmount,
    quantity: plan.quantity,
    code: plan.code,
    type: plan,
  }
}

export const getMonthlySubDetails = (subJSON, currency) => {
  let monthlyCenters = []
  let monthlyAddons = []
  subJSON.plans.map(item => {
    let isCenter = item.name.toLowerCase().includes('center')
    if (isCenter) {
      monthlyCenters.push(getPlanDetail(currency, item))
      if (item.addons.length > 0) {
        item.addons.map(addonItem => {
          if (
            !(
              addonItem.name.toLowerCase().includes('marketing') ||
              addonItem.name.toLowerCase().includes('center')
            )
          ) {
            console.log({name: addonItem.name})
            monthlyAddons.push(getPlanDetail(currency, addonItem))
          }
          return addonItem
        })
      }
    } else if (item.code === 'appmarket-5-thryv-m2m') {
      if (item.addons.length > 0) {
        item.addons.map(addonItem => {
          monthlyAddons.push(getPlanDetail(currency, addonItem))
          return addonItem
        })
      }
    } else {
      monthlyAddons.push(getPlanDetail(currency, item))
    }

    return item
  })
  monthlyCenters = getSortedArray(monthlyCenters, 'name')
  monthlyAddons = getSortedArray(monthlyAddons, 'name')
  let cartList = [...monthlyCenters, ...monthlyAddons]
  let monthlyCartTotal = cartList
    .map(item => item.amount)
    .reduce((acc, curr) => acc + curr)
  return {
    cartList,
    totalDue: formatPrice(monthlyCartTotal),
    paymentCartType: 'monthly',
  }
}
export const getDailySubDetails = (subJSON, currency) => {
  let monthlyCenters = []
  let monthlyAddons = []
  subJSON.plans.map(item => {
    let isCenter = item.name.toLowerCase().includes('center')
    if (isCenter) {
      monthlyCenters.push(getPlanDetail(currency, item))
      if (item.addons.length > 0) {
        item.addons.map(addonItem => {
          if (
            !(
              addonItem.name.toLowerCase().includes('marketing') ||
              addonItem.name.toLowerCase().includes('center')
            )
          ) {
            console.log({name: addonItem.name})
            monthlyAddons.push(getPlanDetail(currency, addonItem))
          }
          return addonItem
        })
      }
    } else if (item.code === 'appmarket-5-thryv-m2m') {
      if (item.addons.length > 0) {
        item.addons.map(addonItem => {
          monthlyAddons.push(getPlanDetail(currency, addonItem))
          return addonItem
        })
      }
    } else {
      monthlyAddons.push(getPlanDetail(currency, item))
    }

    return item
  })
  monthlyCenters = getSortedArray(monthlyCenters, 'name')
  monthlyAddons = getSortedArray(monthlyAddons, 'name')
  let cartList = [...monthlyCenters, ...monthlyAddons]
  let todayCartTotal = cartList
    .map(item => item.amount)
    .reduce((acc, curr) => acc + curr)
  let tax = subJSON?.paymentPreview?.tax || 0
  return {
    cartList,
    totalDue: todayCartTotal + tax,
    tax,
    paymentCartType: 'today',
  }
}

const COMMAND_CENTER_NAME_MAPPING = {
  'cc_basic-5-thryv-m2m': 'My Account',
  'cc_basicpls-5-thryv-m2m': 'My Account',
  'cc_plus-5-thryv-m2m': 'My Account Plus',
  'cc_pro-5-thryv-m2m': 'My Account Pro',
}

const FREE_ACCOUNT_CODES = ['addon-5-signatures_usage', 'app-websitebuilder']
export const formatSubDetails = (subJSON, subList, currency) => {
  let list = [...subList.centers, ...subList.apps, ...subList.oneTimeFees]
  let planArrayList = []
  let addonArrayList = []
  subJSON.plan.map(item => {
    let subExist = list.find(sublist => sublist?.code === item?.code)
    if (subExist) {
      let subCurrency = subExist?.currencies
      let subAmount = subCurrency.find(curr => curr.currency === currency)
      planArrayList.push({
        code: subExist.code,
        quantity: item?.quantity || subAmount?.quantity || 1,
        name: subExist.code.startsWith('cc_')
          ? COMMAND_CENTER_NAME_MAPPING[subExist?.code]
          : subExist.code.startsWith('bc-6')
            ? 'Business Center'
            : subExist.name,
        unitAmount: item?.unitAmount || subAmount?.unitAmount || 0,
        addons: item.addons,
        isAlreadyAdded: item?.isAlreadyAdded || false,
      })
      // if (subExist?.entitlements?.length) {
      //   subExist.entitlements.map(subItem => {
      //     let subCurrency = subItem?.currencies
      //     let subAmount = subCurrency.find(curr => curr.currency === currency)
      //     planArrayList.push({
      //       code: subItem.code,
      //       quantity: subAmount?.quantity || 1,
      //       name: subItem.name,
      //       unitAmount: subAmount?.unitAmount || 0,
      //     })
      //     return subItem
      //   })
      // }
    }

    return item
  })
  subJSON.addons.map(item => {
    let subExist = list.find(sublist => sublist?.code === item?.code)
    if (
      item?.code === 'appmarket-5-thryv-m2m' ||
      item?.code === 'addon-5-keap-addons'
    ) {
      if (item?.addons) {
        item?.addons.map(addon => {
          let subAddOnExist = list.find(
            sublist => sublist?.code === addon?.code,
          )
          if (FREE_ACCOUNT_CODES.includes(addon.code)) {
            addonArrayList.push({
              code: addon.code,
              quantity: addon?.quantity,
              name: addon.name,
              unitAmount: 0,
              isAlreadyAdded: true,
            })
          } else {
            if (subAddOnExist) {
              let subCurrency = subAddOnExist?.currencies
              let subAmount = subCurrency.find(
                curr => curr.currency === currency,
              )
              addonArrayList.push({
                code: subAddOnExist.code,
                quantity: addon?.quantity || subAmount?.quantity || 1,
                name: subAddOnExist.name,
                unitAmount: addon?.unitAmount || subAmount?.unitAmount || 0,
                isAlreadyAdded: addon?.isAlreadyAdded || false,
              })
            }
          }

          return addon
        })
      }
    } else {
      if (subExist) {
        let subCurrency = subExist?.currencies
        let subAmount = subCurrency.find(curr => curr.currency === currency)
        addonArrayList.push({
          code: subExist.code,
          quantity: item?.quantity || subAmount?.quantity || 1,
          name: subExist.name,
          unitAmount: item?.unitAmount || subAmount?.unitAmount || 0,
          isAlreadyAdded: item?.isAlreadyAdded || false,
        })
        if (item?.addons) {
          item?.addons.map(addon => {
            let subAddOnExist = list.find(
              sublist => sublist?.code === addon?.code,
            )
            if (subAddOnExist) {
              let subCurrency = subAddOnExist?.currencies
              let subAmount = subCurrency.find(
                curr => curr.currency === currency,
              )
              addonArrayList.push({
                code: subAddOnExist.code,
                quantity: addon?.quantity || 1,
                name: subAddOnExist.name,
                unitAmount: addon?.unitAmount || subAmount?.unitAmount || 0,
                isAlreadyAdded: addon?.isAlreadyAdded,
              })
            }
            return addon
          })
        }
      }
    }
    return item
  })
  let defaultAddons = [
    {
      name: 'Website Builder',
      code: 'app-websitebuilder',
      quantity: 1,
      unitAmount: 0,
    },
    {
      code: 'addon-5-signatures_usage',
      name: 'Signatures Usage',
      quantity: 1,
      unitAmount: 0,
    },
  ]

  // let defaultOneTimeAddon = [
  //   {
  //     code: 'thryvprfee',
  //     name: 'Onboarding Fee',
  //     quantity: 1,
  //     unitAmount: 250,
  //   },
  // ]

  let parentSub = [
    {
      code: 'cc_basicpls-5-thryv-m2m',
      name: 'My Account Basic+',
      quantity: 1,
      unitAmount: 0,
    },
  ]
  let allAddOns = [...addonArrayList]
  let oneTimeFees = subJSON.oneTimeFees
  let planList = [...planArrayList, ...addonArrayList, ...oneTimeFees]
  let upgradeOrder = planList.some(item => item?.isAlreadyAdded)
  if (!upgradeOrder) {
    planList = [...parentSub, ...planList, ...defaultAddons]
  }
  let totalAmountMonthly = planList
    .map(item => item.unitAmount * (item.quantity || 1))
    .reduce((acc, curr) => acc + curr)
  let totalAmountToday = planList
    .map(item =>
      item?.isAlreadyAdded ? 0 : item.unitAmount * (item.quantity || 1),
    )
    .reduce((acc, curr) => acc + curr)
  let totalDeduction = 0
  if (subJSON.coupons && subJSON.coupons.length > 0) {
    for (let i = 0; i < subJSON.coupons.length; i++) {
      if (subJSON.coupons[i].type === 'fixed') {
        totalDeduction = totalDeduction + subJSON.coupons[i].discountAmount
      } else {
        let validPlanCodes = subJSON.coupons[i]?.appliesToPlans || []
        let appropriatePlan = planList?.find(item =>
          validPlanCodes.includes(item.code),
        )
        if (appropriatePlan) {
          totalDeduction =
            totalDeduction +
            subJSON.coupons[i].discountPercent *
              0.01 *
              appropriatePlan.unitAmount *
              appropriatePlan.quantity
        }
      }
    }
  }
  if (totalDeduction > 0) {
    totalAmountToday = totalAmountToday - totalDeduction
  }
  let childSubscriptions = []
  for (let plan of planArrayList) {
    childSubscriptions.push(plan)
  }
  childSubscriptions.push({
    code: 'appmarket-5-thryv-m2m',
    quantity: 1,
    addons: allAddOns
      .filter(({name, code}) => {
        return (
          name !== 'SEO Keywords' &&
          name !== 'SEO PowerBoost' &&
          name !== 'SEO Non-Guaranteed' &&
          name !== 'Thryv Leads' &&
          name !== 'SEO'
        )
      })
      .map(({code, quantity = 1}) => {
        return {
          code,
          quantity,
        }
      }),
  })
  const isSeo = addonArrayList.find(({name}) => name === 'SEO')
  const keyword = addonArrayList.find(({name}) => name === 'SEO Keywords')
  const powerboost = addonArrayList.find(({name}) => name === 'SEO PowerBoost')
  if (isSeo) {
    for (let addOn of addonArrayList) {
      if (addOn.code === 'seobase-5-thryv-m2m') {
        addOn['addons'] = []
        if (keyword)
          addOn.addons.push({
            code: keyword.code,
            quantity: keyword.quantity,
          })
        if (powerboost)
          addOn.addons.push({
            code: powerboost.code,
            quantity: powerboost.quantity,
          })
        childSubscriptions.push(addOn)
      }
    }
  }

  return {
    plans: planList,
    totalAmount: totalAmountMonthly,
    totalAmountToday: totalAmountToday,
    upgradeOrder: planList.some(item => item?.isAlreadyAdded),
    productSub: {
      parentSubscriptions: [...parentSub],
      childSubscriptions: childSubscriptions,
      oneTimeFees: [...oneTimeFees],
    },
  }
}
export const formatInCodeQuantityStructure = subDetails => {
  let parentSubscriptions = []
  let childSubscriptions = []
  let oneTimeFees = []

  subDetails.parentSubscriptions.map(item => {
    let tempDetails = {
      code: item.code,
      quantity: item?.quantity || 1,
      addons: [],
    }
    let tempAddons = []
    if (item?.addons?.length > 0) {
      item.addons.map(subItem => {
        tempAddons.push({code: subItem.code, quantity: subItem?.quantity || 1})
        return subItem
      })
    }
    tempDetails.addons = tempAddons
    parentSubscriptions.push(tempDetails)
    return item
  })
  subDetails.childSubscriptions.map(item => {
    let tempDetails = {
      code: item.code,
      quantity: item?.quantity || 1,
      addons: [],
    }
    let tempAddons = []
    if (item?.addons?.length > 0) {
      item.addons.map(subItem => {
        tempAddons.push({code: subItem.code, quantity: subItem?.quantity || 1})
        return subItem
      })
    }
    tempDetails.addons = tempAddons
    childSubscriptions.push(tempDetails)
    return item
  })
  subDetails?.oneTimeFees?.map(item => {
    let tempDetails = {
      code: item.code,
      quantity: item?.quantity || 1,
      addons: [],
    }
    let tempAddons = []
    if (item?.addons?.length > 0) {
      item.addons.map(subItem => {
        tempAddons.push({code: subItem.code, quantity: subItem?.quantity || 1})
        return subItem
      })
    }
    tempDetails.addons = tempAddons
    oneTimeFees.push(tempDetails)
    return item
  })
  return {parentSubscriptions, childSubscriptions, oneTimeFees}
}

export function getFormattedTime(dateStr) {
  return dayjs(dateStr.start_time).tz(dateStr.timezone).format('h:mm A z')
}
export function getFormattedDate(dateStr) {
  return dayjs(dateStr.start_time).tz(dateStr.timezone).format('D MMM YYYY')
}

export function getFormattedDateTime(dateStr) {
  if (dateStr?.timezone && dateStr?.timezone?.length > 0) {
    if (dateStr?.timezone?.includes('Eastern Daylight Time')) {
      return (
        dayjs(dateStr?.start_time).format('MMMM D[,] YYYY [@] h:mm A ') + 'EDT'
      )
    } else {
      return dayjs(dateStr?.start_time)
        .tz(dateStr?.timezone)
        .format('MMMM D[,] YYYY [@] h:mm A z')
    }
  } else {
    return (
      dayjs(dateStr?.start_time).format('MMMM D[,] YYYY [@] h:mm A ') + 'CDT'
    )
  }
}
